import { Injectable } from '@angular/core';
import { Identity } from '../../interfaces/auth';
import { IUser } from '../../../pages/users/core/interfaces/IUser';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  getIdentity(): Identity | null {
    return window.localStorage['identity'] !== undefined
      ? JSON.parse(window.localStorage['identity']) as Identity
      : null;
  }

  getAccessToken(): string {
    const identity = this.getIdentity();
    if (identity) {
      return identity.accessToken;
    }
    return '';
  }

  getRefreshToken(): string {
    const identity = this.getIdentity();
    if (identity) {
      return identity.refreshToken;
    }
    return '';
  }

  saveIdentity(identity: Identity) {
    window.localStorage['identity'] = JSON.stringify(identity);
  }

  destroyIdentity() {
    window.localStorage.removeItem('identity');
  }

  updateIdentityClaims(userObject: IUser) {
    const identity = this.getIdentity();
    identity.claims = {...identity.claims, ...userObject};
    this.saveIdentity(identity);
  }

  clearWorkstationMode(): void {
    window.localStorage.removeItem('workstationMode');
    window.localStorage.removeItem('expiredTime');
  }

  canEditRecipes(): boolean {
    const identity = this.getIdentity();
    if (!identity) {
      return false;
    }
    if (identity.role === 'Administrator') {
      return true;
    }
    const value = identity.claims?.canEditRecipes;
    if (value === true) {
      return true;
    }
    return typeof value === 'string' && value.toLowerCase() === 'true';
  }
}
